export default __webpack_public_path__ + "static/escapetheroomers-59e4227eb0f0e66050206cafd0467ae9.jpg";